export const frFR = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Lassie",
  legalName: "Lassie AB",
  url: "https://fr.lassie.co",
  logo: "https://fr.lassie.co/images/logo-with-name.svg",
  description:
    "L'assurance animaux la plus innovante de France avec des prix transparents, un traitement rapide des sinistres et des soins préventifs. La première véritable assurance animale préventive en France.",
  email: "contact@lassie.fr",
  address: {
    "@type": "PostalAddress",
    streetAddress: "9 rue des Colonnes",
    postalCode: "75002",
    addressLocality: "Paris",
    addressCountry: "FR",
  },
  sameAs: [
    "https://www.facebook.com/people/Lassie-France/61558443117226/",
    "https://www.instagram.com/lassie_fr/",
    "https://www.linkedin.com/company/lassieco/",
    "https://www.youtube.com/@lassie_co",
  ],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Assurances",
    itemListElement: [
      {
        "@type": "OfferCatalog",
        name: "Assurance pour chiens",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Assurance chien Bronze",
              description: "Une protection de base pour les soins vétérinaires avec couverture pour maladie et accident jusqu'à 1 000 €.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://fr.lassie.co/signup/?species=dog",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Assurance chien Argent",
              description: "Tous les essentiels à un prix raisonnable avec couverture pour maladie et accident jusqu'à 2 000 €.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://fr.lassie.co/signup/?species=dog",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Assurance chien Or",
              description: "Rembourse les frais de santé importants avec couverture pour maladie et accident jusqu'à 5 000 €.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://fr.lassie.co/signup/?species=dog",
              },
            ],
          },
        ],
      },
      {
        "@type": "OfferCatalog",
        name: "Assurance pour chats",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Assurance chat Bronze",
              description: "Une protection de base pour les soins vétérinaires avec couverture pour maladie et accident jusqu'à 1 000 €.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://fr.lassie.co/signup/?species=cat",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Assurance chat Argent",
              description: "Tous les essentiels à un prix raisonnable avec couverture pour maladie et accident jusqu'à 2 000 €.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://fr.lassie.co/signup/?species=cat",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Assurance chat Or",
              description: "Rembourse les frais de santé importants avec couverture pour maladie et accident jusqu'à 5 000 €.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://fr.lassie.co/signup/?species=cat",
              },
            ],
          },
        ],
      },
    ],
  },
};
